import { Injectable } from '@angular/core';
import { DiscussionRequestStates, DiscussionStateMessages } from './discussion-request-states';
import { RxEmitter } from 'common/rxjs/rx-emitter';
import { MessageBusEvents } from 'common/common/constants/message-bus-events';
import { UserPermissionService } from '../../services/user-permissions/user-permission.service';
import { ActionPermissionType } from 'common/common/constants/permission-type-enum';
import { WorkItemTypes } from '../../../common/workitems/constants/workitem-types';
import { BcConfigService } from 'common/config/provider';

@Injectable()
export class DiscussionsService {
  private _discussionRequestStates = DiscussionRequestStates;

  constructor(private RxEmitter: RxEmitter,
              private _bcConfig: BcConfigService,
              private _userPermissionService: UserPermissionService) {
  }

  public changeRequestStatus(item, workItemId) {
    const state = this._convertStringStateToEnum(item.DiscussionMessage);
    this._discussionStateChange(state, workItemId);
  }

  public isDiscussionsEnabled(): boolean {
    return this._bcConfig.current.features.discussions;
  }

  public hasDiscussionPermission(workItemType: WorkItemTypes): boolean {
    switch (workItemType) {
      case WorkItemTypes.CHAT:
        return this._userPermissionService.hasPermissionFor(ActionPermissionType.CHAT_DISCUSSION);
      case WorkItemTypes.EMAIL:
        return this._userPermissionService.hasPermissionFor(ActionPermissionType.EMAIL_DISCUSSION);
      default:
        return false;
    }
  }

  private _convertStringStateToEnum(state): string {
    switch (state) {
      case DiscussionStateMessages.ACCEPTED:
        return this._discussionRequestStates.ACCEPTED;
      case DiscussionStateMessages.INITIATED:
      case DiscussionStateMessages.INITIATED_ACD:
        return this._discussionRequestStates.WAITING;
      case DiscussionStateMessages.CANCELLED:
        return this._discussionRequestStates.NOT_SET;
      case DiscussionStateMessages.ENDED:
        return this._discussionRequestStates.ENDED;
      default:
        throw Error('Unknown discussion status type');
    }
  }

  private _discussionStateChange(state, workItemId) {
    this.RxEmitter.send(MessageBusEvents.DiscussionStateChanged + `-${workItemId}`, state);
  }
}
